const skills = {
    languages: [
        {
            name: "Python",
            image: "https://www.vectorlogo.zone/logos/python/python-icon.svg"
        },
        {
            name: "Golang",
            image: "https://www.vectorlogo.zone/logos/golang/golang-icon.svg"

        },
        {
            name: "Java",
            image: "https://www.vectorlogo.zone/logos/java/java-icon.svg"
        },
        {
            name: "C++",
            image: "https://user-images.githubusercontent.com/42747200/46140125-da084900-c26d-11e8-8ea7-c45ae6306309.png"
        },
        {
            name: "Dart",
            image: "https://www.vectorlogo.zone/logos/dartlang/dartlang-icon.svg"

        },
        {
            name: "JavaScript",
            image: "https://raw.githubusercontent.com/voodootikigod/logo.js/master/js.png"

        }],
    cloud: [{
        name: "AWS",
        image: "https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-ar21.svg"
    }, {
        name: "Google Cloud",
        image: "https://www.vectorlogo.zone/logos/google_cloud/google_cloud-icon.svg"
    }],

    frameWorks: [
        {
            name: "React",
            image: "https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg"
        },
        {
            name: "Flutter",
            image: "https://www.vectorlogo.zone/logos/flutterio/flutterio-icon.svg"
        },
        {
            name: "Django",
            image: "https://www.vectorlogo.zone/logos/djangoproject/djangoproject-icon.svg"
        },
        {
            name: "Flask",
            image: "https://flask.palletsprojects.com/en/1.1.x/_static/flask-icon.png"
        },
        {
            name: "Fiber",
            image: "https://gblobscdn.gitbook.com/spaces%2F-M-XEvRn3rhe8BDVGkss%2Favatar-rectangle.png?alt=media"
        },
        {
            name: "BootStrap",
            image: "https://www.vectorlogo.zone/logos/getbootstrap/getbootstrap-icon.svg"
        }],
    databases: [
        {
            name: "MySQl",
            image: "https://www.vectorlogo.zone/logos/mysql/mysql-icon.svg"
        },
        {
            name: "Postgres",
            image: "https://www.vectorlogo.zone/logos/postgresql/postgresql-ar21.svg"
        },
        {
            name: "mongoDB",
            image: "https://www.vectorlogo.zone/logos/mongodb/mongodb-icon.svg"

        },
        {
            name: "ElasticSearch",
            image: "https://www.vectorlogo.zone/logos/elastic/elastic-icon.svg"
        },
    ],
    other: [
        {
            name: "HTML 5", image: "https://www.vectorlogo.zone/logos/w3_html5/w3_html5-icon.svg"
        },
        {
            name: "CSS 3", image: "https://d29fhpw069ctt2.cloudfront.net/icon/image/38785/preview.svg"
        },
        {
            name: "Firebase",
            image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg"

        },
        {
            name: "Git",
            image: "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg"

        },
        {
            name: "Figma",
            image: "https://www.vectorlogo.zone/logos/figma/figma-icon.svg"
        },
        {
            name: "Github",
            image: "https://www.vectorlogo.zone/logos/github/github-icon.svg"

        },
        {
            name: "Gitlab",
            image: "https://www.vectorlogo.zone/logos/gitlab/gitlab-tile.svg"
        },
        {
            name: "Machine Learning",
            image: "https://ml-algo-visualizer.web.app/static/media/machinelearning.cf8c2897.png"
        }
    ]
}

export default skills;